import { getNumericValue, passwordValidation, validateEmail } from "../utils";
import { useState } from "preact/hooks";
import { styled } from "@mui/material/styles";
import { IconButton, InputAdornment, TextField, Button } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import BasicModal from "./common/basicModal";
import { Fragment } from "preact";
import ResendOTP from "./common/resendOtp";
import { route } from "preact-router";

const Container = styled("div")`
  height: 100vh;
  min-height: 500px;
  color: #fff;
  background-color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .headerText {
    color: #f7f7f7;
    font-size: 36px;
    font-weight: 700;
    line-height: 48px;
    text-align: center;
  }
  .subText {
    margin: 2.222vh 0px 3.889vh;
    padding: 0px 10px;
    min-width: 250px;
    color: #f7f7f7;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
  }
  .inputField {
    margin-top: 25px;
    width: 90vw !important;
    max-width: 600px;
    min-width: 250px;
    height: 56px !important;
  }
  .emailInputField {
    margin-top: 3.889vh;
    width: 46.35vw !important;
    min-width: 128.75px;
    max-width: 309px;
    height: 56px !important;
  }
  .otpInputField {
    margin-top: 3.889vh;
    width: 23.697vw !important;
    min-width: 65.825px;
    max-width: 158px;
    height: 56px !important;
  }
  .loginButton {
    margin-top: 25px;
    width: 90vw;
    max-width: 600px;
    min-width: 250px;
    font-size: 18px;
    line-height: 60px;
    text-transform: none;
    background-color: #6741d9;
    height: 60px;
    color: #fff;
    max-width: 600px;
    min-width: 250px;
    text-transform: none;
    border-radius: 16px;
    font-family: Poppins;
  }
  .loginButton:hover {
    border: #f0c3f1 1px solid;
    background-color: #6741d9;
  }
  .loginButton:disabled {
    background-color: #808080;
    color: #000000;
  }
  .sendOtpButton {
    width: 15.75vw;
    min-width: 43.75px;
    max-width: 105px;
    margin: 4vh 1.3vw 0px;
    text-transform: none;
    height: 36px;
    padding: 0px 8px;
    border: 0;
    box-sizing: border-box;
    border-radius: 16px;
    box-shadow: -1px 1px 10px #f0c3f1;
    background-color: #6741d9;
    color: #ffffff;
    font-size: 15px;
    font-weight: 600;
    line-height: 20px;
    outline: none;
  }
  .sendOtpButton:hover {
    border: #f0c3f1 1px solid;
    background-color: #6741d9;
  }
  .sendOtpButton:disabled {
    background-color: #808080;
    color: #000000;
  }
  .forgotLink {
    margin-top: 20px;
    color: white;
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
    color: #f7f7f7;
  }
  a:visited {
    color: #f7f7f7;
    text-decoration: underline;
    text-decoration-color: #f7f7f7;
  }
  .continueWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
  }
  .inputWrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .passwordText {
    margin-top: 2.222vh;
    cursor: pointer;
  }
  .resendOtpContainer {
    margin: 35px 15px 0 15px;
  }
`;

const WhiteBorderTextField = styled(TextField)`
  & .MuiOutlinedInput-root {
    & fieldset {
      border-color: #FFF !important;
      border-radius: 8px;
    },
    &.Mui-focused fieldset {
      border-color: #FFF !important;
    },
  },
`;

function ForgotPassword() {
  const [email, setEmail] = useState({ mail: "" });
  const [emailError, setEmailError] = useState("");
  const [otp, setOtp] = useState({ otp: "" });
  const [newpassword, setNewpassword] = useState({ pass: "" });
  const [passwordError, setPasswordError] = useState("");
  const [reEnteredPassword, setReEnteredPassword] = useState({ pass: "" });
  const [reEnteredPasswordError, setReEnteredPasswordError] = useState("");
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showReEnteredPassword, setShowReEnteredPassword] = useState(false);
  const [isSendOtpButtonActive, setIsSendOtpButtonActive] = useState(true);
  const handleClickShowNewPassword = () => setShowNewPassword(!showNewPassword);
  const handleMouseDownNewPassword = () => setShowNewPassword(!showNewPassword);
  const handleClickShowReEnteredPassword = () =>
    setShowReEnteredPassword(!showReEnteredPassword);
  const handleMouseDownReEnteredPassword = () =>
    setShowReEnteredPassword(!showReEnteredPassword);
  const handleCloseErrorModal = () => setOpenErrorModal(false);
  const handleCloseSuccessModal = () => setOpenSuccessModal(false);
  const resetPassword = () => {
    setOpenSuccessModal(true);
  };
  const sendOtp = () => {
    //call api
    setIsSendOtpButtonActive(false);
  };

  const resendOTP = () => {
    //resendOTP
  };
  const handleOnClick = () => {
    route("/sign-in/");
  };

  return (
    <Fragment>
      <Container>
        <div className="headerText">Forgot Password?</div>
        <div className="subText">
          Reset password to restart creating memories.
        </div>
        <div className="inputWrapper">
          <WhiteBorderTextField
            className="emailInputField"
            sx={{ input: { color: "white" } }}
            InputLabelProps={{
              style: {
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                width: "100%",
                color: "#808080",
              },
            }}
            id="email"
            autoComplete="on"
            style={{ width: "100%", marginTop: "30px" }}
            placeholder="Email"
            variant="outlined"
            onChange={(e) => {
              setEmail({ mail: e.target.value });
              validateEmail(email.mail)
                ? setEmailError("")
                : setEmailError("Enter a valid email");
            }}
            onBlur={() => {
              validateEmail(email.mail)
                ? setEmailError("")
                : setEmailError("Enter a valid email");
            }}
            value={email.mail}
            error={!!emailError}
            helperText={emailError && emailError}
          />
          {isSendOtpButtonActive ? (
            <Button
              className="sendOtpButton"
              onClick={() => {
                sendOtp();
              }}
            >
              Send OTP
            </Button>
          ) : (
            <div className="resendOtpContainer">
              <ResendOTP
                color="rgba(0, 0, 0, 0.8)"
                resendOTP={() => {
                  resendOTP();
                }}
              />
            </div>
          )}
          <WhiteBorderTextField
            className="otpInputField"
            sx={{ input: { color: "white" } }}
            InputLabelProps={{
              style: {
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                width: "100%",
                color: "#808080",
              },
            }}
            id="enter-otp"
            autoComplete="off"
            style={{ width: "100%", marginTop: "30px" }}
            placeholder="Enter OTP"
            variant="outlined"
            inputProps={{
              maxLength: 6,
            }}
            onChange={(e) => {
              setOtp({ otp: getNumericValue(e.target.value) });
            }}
            value={otp.otp}
          />
        </div>
        <WhiteBorderTextField
          className="inputField"
          sx={{ input: { color: "white" } }}
          placeholder="Enter New Password"
          InputLabelProps={{
            style: {
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
              width: "100%",
              color: "#808080",
            },
          }}
          variant="outlined"
          type={showNewPassword ? "text" : "password"}
          value={newpassword.pass}
          onChange={(e) => {
            setNewpassword({ pass: e.target.value });
            setPasswordError(passwordValidation(e.target.value));
          }}
          onBlur={() => {
            setPasswordError(passwordValidation(newpassword.pass));
          }}
          error={!!passwordError}
          helperText={passwordError && passwordError}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  style={{ color: "white" }}
                  aria-label="toggle password visibility"
                  onClick={handleClickShowNewPassword}
                  onMouseDown={handleMouseDownNewPassword}
                >
                  {showNewPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <WhiteBorderTextField
          className="inputField"
          sx={{ input: { color: "white" } }}
          placeholder="Re-enter password"
          InputLabelProps={{
            style: {
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
              width: "100%",
              color: "#808080",
            },
          }}
          variant="outlined"
          type={showReEnteredPassword ? "text" : "password"}
          value={reEnteredPassword.pass}
          onChange={(e) => {
            setReEnteredPassword({ pass: e.target.value });
            e.target.value === newpassword.pass
              ? setReEnteredPasswordError("")
              : setReEnteredPasswordError("Password does not match");
          }}
          onBlur={(e) => {
            reEnteredPassword.pass === newpassword.pass
              ? setReEnteredPasswordError("")
              : setReEnteredPasswordError("Password does not match");
          }}
          error={!!reEnteredPasswordError}
          helperText={reEnteredPasswordError && reEnteredPasswordError}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  style={{ color: "white" }}
                  aria-label="toggle password visibility"
                  onClick={handleClickShowReEnteredPassword}
                  onMouseDown={handleMouseDownReEnteredPassword}
                >
                  {showReEnteredPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Button
          className="loginButton"
          disabled={
            !passwordValidation(newpassword.pass) === "" ||
            newpassword.pass === "" ||
            (reEnteredPassword.pass !== newpassword.pass &&
              newpassword.pass !== "") ||
            !validateEmail(email.mail) ||
            otp.otp.length !== 6
          }
          onClick={() => {
            resetPassword();
          }}
        >
          Reset Password
        </Button>
        <div className="passwordText">
          Got your password?{" "}
          <a
            href={"/sign-in/"}
            className="forgotLink"
            style={{ fontWeight: "600" }}
          >
            Login
          </a>
        </div>
      </Container>
      <BasicModal open={openErrorModal} handleClose={handleCloseErrorModal}>
        <div className="modalHeaderText">Oppssss...</div>
        <div className="modalSubText">
          Username and Password Mismatch - Give it Another Shot.
        </div>
        <Button
          className="modalButton"
          onClick={() => {
            handleCloseErrorModal();
          }}
        >
          Try Again
        </Button>
      </BasicModal>

      <BasicModal open={openSuccessModal} handleClose={handleCloseSuccessModal}>
        <div className="modalHeaderText">Great Job!</div>
        <div className="modalSubText">
          You password has been reset. <br /> Unleash the power of song
          requests, AGAIN!
        </div>
        <Button
          className="modalButton"
          onClick={() => {
            handleOnClick();
          }}
        >
          Sign In
        </Button>
      </BasicModal>
    </Fragment>
  );
}

export default ForgotPassword;
